import { bootstrapApplication } from "@angular/platform-browser";
import { init as sentryInit } from "@sentry/angular";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { sentryBrowserOptions } from "./app/core/config/sentry.config";
import { isDevelopment, isLocal } from "./app/core/constants/is-development";

function sentryMain(): void {
  try {
    if (!isDevelopment && !isLocal) {
      sentryInit(sentryBrowserOptions);
    }
  } catch (err: unknown) {
    console.error(err);
  }
}

(async function main() {
  try {
    sentryMain();
    await bootstrapApplication(AppComponent, appConfig);
  } catch (err: unknown) {
    console.error(err);
  }
})();
